import { render, staticRenderFns } from "./translationIcon.vue?vue&type=template&id=57fd42e0&"
import script from "./translationIcon.vue?vue&type=script&lang=js&"
export * from "./translationIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/digital-seaside/sst-admin-panel/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('57fd42e0')) {
      api.createRecord('57fd42e0', component.options)
    } else {
      api.reload('57fd42e0', component.options)
    }
    module.hot.accept("./translationIcon.vue?vue&type=template&id=57fd42e0&", function () {
      api.rerender('57fd42e0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/translation-icon/translationIcon.vue"
export default component.exports